<template>
    <div class="scramble">
        <div>
            <XInput
                v-validate="{ required: true }"
                @input="handleScrambleInputAnswer($event)"
                :value="answer.title"
                :name="`answer-${questionIndex}`"
                :placeholder="$t('question_placeholder_correct_answer')"
                :disabled="!canEditQuiz"
                data-vv-as="typing answer"
                autocomplete="off"
                class="input input-block input-remove-margin input-text-alignment font-size-16 md:font-size-20"
                type="text"
                style="text-transform: uppercase"
                maxlength="25"
            />
        </div>
        <span
            v-if="errors.has(`answer-${questionIndex}`) && !answer.title"
            class="has-error text-red text-center mt-2 font-size-14 shadow-text-none"
            >* {{ errors.first(`answer-${questionIndex}`) }}</span
        >
        <div
            v-if="isTitleTooLong(answer.title)"
            class="has-error text-red text-center mt-2 font-size-14 shadow-text-none"
        >
            <span class="block">{{ $t('question_alert_text_answer_toolong') }}</span>
            <span class="block pt-2"> {{ $t('question_alert_text_answer_tip') }} </span>
        </div>
    </div>
</template>

<script>
import quizCreator from '@/mixins/quiz-creator.js'
import XInput from '@/components/v2/XInput'

export default {
    components: {
        XInput
    },

    mixins: [quizCreator],

    props: {
        questionIndex: {
            type: Number,
            required: true
        },

        answer: {
            type: Object,
            required: true
        }
    },

    methods: {
        handleScrambleInputAnswer(event) {
            if (!this.canEditQuiz) return

            event = event.target.value

            let answer = event.trim()
            answer = answer.replace(/\s\s+/g, ' ')

            this.$store.commit('updateAnswerTitle', {
                value: answer.toUpperCase(),
                questionIndex: this.questionIndex,
                answerIndex: 0
            })
        },

        isTitleTooLong(text) {
            if (text.length > 10) {
                return true
            }
        }
    }
}
</script>

<style>
</style>